// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useMemo, useEffect, createContext, useContext, Component, useSearchParams } from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link, useLocation } from 'react-router-dom';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
//import Ts from "./TS.tsx";
import { useIntl, FormattedMessage } from 'react-intl';
import ReactGA from "react-ga4";
import Refresh from './components/refresh';
import RichTextEditor from './RichTextEditor';
import { LoginContext, AuthContext, LoadingContext, MsgContext, MsgOpenContext, MsgOpenErrContext } from '../Default';
import SessionTimeout from './SessionTimeout';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import { colors } from '@mui/material';
//import { data, type Person } from './makeData';
import { type Tag } from "./data/tdb_c2";
import './TS.css';
import Chip from '@mui/material/Chip';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { stix } from './data/tdb_c2.tsx';
import logo from '../../TIP_tate.svg';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import ja from "date-fns/locale/ja";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import Popover from '@mui/material/Popover';
import {
  Tooltip,
} from '@mui/material';
import $ from 'jquery';
window.jQuery = require("jquery");
import SummernoteLite from "react-summernote-lite";
window.jQuery = $;
require('bootstrap');
import 'react-summernote/dist/react-summernote.css'; // import styles
import 'react-summernote/lang/summernote-ja-JP.js'; // you can import any other locale // you can import any other locale
import 'react-summernote-lite/dist/lang/summernote-ja-JP.min';
import 'react-summernote-lite/dist/font/summernote.ttf';
import 'bootstrap/dist/css/bootstrap.css';
import 'summernote/dist/summernote.css';
import 'summernote/dist/summernote-bs4.css';
import 'react-summernote/dist/react-summernote.css';
import 'react-summernote-lite/dist/summernote-lite.min.css';
import 'jquery';
import 'popper.js';
import 'bootstrap';
// import 'summernote/dist/summernote-bs4.js';
// Import bootstrap(v3 or v4) dependencies
// import 'bootstrap/js/src/modal';
// import 'bootstrap/js/src/dropdown';
// import 'bootstrap/js/src/tooltip';
// import 'bootstrap/dist/css/bootstrap.min.css';
import parse from 'html-react-parser';
import { uploadData } from 'aws-amplify/storage';
import AWS from 'aws-sdk'
import { v4 as uuidv4 } from 'uuid';
import {
  PutObjectCommand,
  S3Client,
  S3ServiceException,
} from "@aws-sdk/client-s3";
import './ColumnDetail.css';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import Grid from '@mui/material/Grid';
import { Helmet } from 'react-helmet-async';

interface IState {
  progress: number,
}
interface IProps {
}
//import './Column.css';
//import {RefreshContext} from './SearchResult';
// Google Analytics 測定 ID を入力して設定
ReactGA.initialize(process.env.REACT_APP_GA_KEY);
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));
//export const RefreshContext = createContext();
const handleReady = () => {

};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];
function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = () => {
      reject(new Error('Failed to read the file.'));
    };
    reader.readAsDataURL(file);
  });
}

function getStyles(name: string, tag: readonly string[], theme: Theme) {
  return {
    fontWeight: tag.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '1px solid',
  boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
  backgroundImage: `url(${'/static/images/templates/templates-images/hero-light.png'})`,
  outlineColor: 'hsla(220, 25%, 80%, 0.5)',
  backgroundSize: 'cover',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
    height: 700,
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 24px 12px hsla(210, 100%, 25%, 0.2)',
    backgroundImage: `url(${'/static/images/templates/templates-images/hero-dark.png'})`,
    outlineColor: 'hsla(210, 100%, 80%, 0.1)',
  }),
}));
const styles = (theme: { spacing: { unit: number; }; shape: { borderRadius: any; }; breakpoints: { up: (arg0: string) => any; }; transitions: { create: (arg0: string) => any; }; }) => ({
  root: {
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit,
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200,
      },
    },
  },
});
const useUploadButtonStyles = styled(DialogTitle)(({ theme }) => createStyles({
  input: {
    display: 'none',
  },
})
);
function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
export default function ColumnDetail() {
  const intl = useIntl();
  const noteRef = React.useRef();
  let locale;
  if (intl.locale == "ja") {
    locale = MRT_Localization_JA
  } else {
    locale = MRT_Localization_EN
  }
  const location = useLocation();
  const [searchParams, setSearchParams] = useLocation().search;
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();
  const queryId = query.get('_id') || null;
  const [category, setCategory] = React.useState(location.state !== null && location.state.hasOwnProperty("category") ? location.state["category"] : "0");
  const [keyword, setKeyword] = React.useState(location.state !== null && location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "");
  const [_id, set_Id] = React.useState(queryId ? queryId : location.state !== null && location.state.table.hasOwnProperty("_id") ? location.state.table["_id"] : "");
  const [id, setId] = React.useState(location.state !== null && location.state.table.hasOwnProperty("id") && location.state.hasOwnProperty("category") && location.state["category"] !== "copy" ? location.state.table["id"] : uuidv4());
  const [title, setTitle] = React.useState(location.state !== null && location.state.table.hasOwnProperty("title") ? location.state.table["title"] : "");
  const [bf, setBf] = React.useState((location.state !== null && location.state.hasOwnProperty("bf") && location.state["bf"] == "ad") ? "/ColumnManage" : "/Column");
  const [createDate, setCreateDate] = React.useState(location.state !== null && location.state.table.hasOwnProperty("date") ? location.state.table["date"] : dayjs().format("YYYY/MM/DD"));
  const [startDate, setStartDate] = React.useState(location.state !== null && location.state.table.hasOwnProperty("start_date") ? location.state.table["start_date"] : dayjs().format("YYYY/MM/DD HH:mm"));
  const [endDate, setEndDate] = React.useState(location.state !== null && location.state.table.hasOwnProperty("end_date") ? location.state.table["end_date"] : "");
  //const [refreshKey, setRefreshKey] = React.useState(0);
  //const [isActive, setIsActive] = useState(false);
  //const [category] = React.useState(location.state["category"]);
  //const [keyword] = React.useState(location.state["keyword"]);
  const [posts, setPosts] = React.useState<Post[]>([]);
  const [postsSeo,setPostsSeo] = React.useState<Post[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [open5, setOpen5] = React.useState(true);
  const { login, setLogain } = useContext(LoginContext);
  const { auth, setAuth } = useContext(AuthContext);
  const { loading, setLoading } = useContext(LoadingContext);
  const { msg, setMsg } = useContext(MsgContext);
  const { msgOpen, setMsgOpen } = useContext(MsgOpenContext);
  const { msgOpenErr, setMsgOpenErr } = useContext(MsgOpenErrContext);
  const [tag, setTag] = React.useState<string[]>(location.state !== null && location.state.table.hasOwnProperty("tag") ? location.state.table["tag"] : []);
  const [ver, setVer] = React.useState<string[]>(location.state !== null && location.state.table.hasOwnProperty("ver") && location.state.hasOwnProperty("category") && location.state["category"] !== "copy" && location.state.table["ver"] !== 999999 ? location.state.table["ver"] : 0);
  const theme = useTheme();
  const [textareaContents, setTextareaContents] = React.useState(location.state !== null && location.state.table.hasOwnProperty("id") ? "" : "<p><br></p>");
  const [textareaContentsSub, setTextareaContentsSub] = React.useState(location.state !== null && location.state.table.hasOwnProperty("id") ? "" : "");
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [open6, setOpen6] = React.useState(false);
  const element = React.useRef(null);
  const element2 = React.useRef(null);

  // const value = {
  //   refreshKey,
  //   setRefreshKey,
  // };
  const [thumbnail, setThumbnail] = React.useState(location.state !== null && location.state.table.hasOwnProperty("thumbnail") ? location.state.table["thumbnail"] : "");
  const [mok, setMok] = React.useState(location.state !== null && location.state.hasOwnProperty("category") && location.state["category"] !== "find" ? true : false);
  const [mok2, setMok2] = React.useState(true);
  const [image, setImage] = React.useState<File>()
  const [open1, setOpen1] = React.useState(false);
  const [ErrMs, setErrMs] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState<
    Record<string, string | undefined>
  >({});

  const handleClickOpen = () => {
    setOpen6(true);
  };
  const handleUpload = () => {
    handleUploadSend().then((response) => {
      if (!response.ok) {
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    });
  };

  // 画像をサーバーにアップロードする関数
  async function uploadImage(fileList) {
    const formData = new FormData();
    const url = process.env.REACT_APP_COLUMN_API_URL;
    formData.append('image', fileList[0]);
    if (fileList[0]) { // file が undefined でないことを確認
      let bodyData;
      // BufferをBase64文字列に変換
      const base64 = await convertToBase64(fileList[0]);
      noteRef.current.summernote("insertImage", base64, fileList[0].name);
      bodyData = {
        category: "16",
        img: base64,
      };
      const formData = new FormData();
      formData.append('file', base64);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      // setLoading(true);
      // return fetch(url, {
      //     method: 'POST',
      //     headers: headers,
      //     body: JSON.stringify(bodyData)
      //   })
      //   .then((response) => {
      //     if (!response.ok ){
      //       setLoading(false);
      //       throw new Error('status is not 200');
      //     }
      //     return response.json();
      //   })
      //   .then(jsondata => {
      //     console.log(response);
      //     noteRef.current.summernote("insertImage", jsondata.url, fileList[0].name);
      //   })
    } else {
      alert(`ファイルが選択されていません。`)
      return null;
    }
  };
  async function handleUploadSend(img) {
    const url = process.env.REACT_APP_COLUMN_API_URL;
    setThumbnail("");
    if (img) { // file が undefined でないことを確認
      const formData = new FormData();
      formData.append('image', img);
      let bodyData;
      // BufferをBase64文字列に変換
      const base64 = await convertToBase64(img);
      setThumbnail(base64);
      //const base64String = imageBuffer.toString('base64');
      bodyData = {
        category: "16",
        img: base64,
      };

      formData.append('file', img);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });

    } else {
      alert(`ファイルが選択されていません。`)
      return null;
    };
  }
  const handleClose = () => {
    setOpen6(false);
  };
  const initSN = () => {
    ReactSummernote.insertText(textareaContents);
  };
  const ChangeMok = () => {
    setMok(false);
  };

  const getImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    const img: File = e.target.files[0]
    setImage(img)
    handleUploadSend(img);
  }
  const tagChange = (event: SelectChangeEvent<typeof tag>) => {
    const {
      target: { value },
    } = event;
    setTag(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  function onChange(content: any) {
    setTextareaContents(content);
    let contentSub = content.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
    setTextareaContentsSub(contentSub);
  };
  const tagManage = () => {
    setOpen4(true);
  }
  const returnButton = document.getElementById("returnButton");
  const saveColumn = async () => {
    if (title != "" && thumbnail != "" && createDate != "" && startDate) {
      await saveColumnFunc("");
      setMsg("langID00072");
      setMsgOpen(true);
      setTimeout(() => {
        setMsgOpen(false);
      }, 5000);
      returnButton?.click();
      return true;
    }
    setMsg("langID00073");
    setMsgOpenErr(true);
    setTimeout(() => {
      setMsgOpenErr(false);
    }, 5000);
    return false;
  }
  const saveTempColumn = async () => {
    if (title != "") {
      await saveColumnFunc("temp");
      setMsg("langID00072");
      setMsgOpen(true);
      setTimeout(() => {
        setMsgOpen(false);
      }, 5000);
      returnButton?.click();
      return true;
    }
    setMsg("langID00074");
    setMsgOpenErr(true);
    setTimeout(() => {
      setMsgOpenErr(false);
    }, 5000);
    return false;
  }
  const deleteColumn = async () => {
    await saveColumnFunc("del");
    setOpen1(false);
    const returnButton = document.getElementById("returnButton");
    setMsg("langID00072");
    setMsgOpen(true);
    setTimeout(() => {
      setMsgOpen(false);
    }, 5000);
    returnButton?.click();
    return true;
  }
  async function saveColumnFunc(key: string) {
    try {
      const url = process.env.REACT_APP_COLUMN_API_URL;

      let bodyData;
      if (key == "temp") {
        bodyData = {
          category: "0",
          id: id,
          thumbnail: thumbnail,
          title: title,
          date: createDate,
          start_date: startDate,
          end_date: endDate,
          content: textareaContents,
          contentSub: textareaContentsSub,
          tag: tag,
          ver: 999999,
        };
      } else if (key == "del") {
        bodyData = {
          category: "1",
          id: id,
        };
      } else {
        bodyData = {
          category: "0",
          id: id,
          thumbnail: thumbnail,
          title: title,
          date: createDate,
          start_date: startDate,
          end_date: endDate,
          content: textareaContents,
          contentSub: textareaContentsSub,
          tag: tag,
          ver: ver + 1,
        };
      }

      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('status is not 200');
          }
          return;

        })
    } catch {
      return;
    }
  }

  const editingHandler = () => {
    if (id != "" && pass != "") {
      Login(id, pass);
    }
    return false;
  }


  const submitImage = () => {
    const header = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
      }
    }
    const data = new FormData()
    data.append('file', image)
    const postImageUri = '任意のURL'
      // axios.post(postImageUri, data, header)
      .then(res => {
        //任意の処理
      }).catch(err => {
        //任意の処理
      })
  }
  const handleChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value);

  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  }
  const changeTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  }
  const changeTag = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTag(event.target.value);
  }
  const changeCreateDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCreateDate(event.format("YYYY/MM/DD"));
  }
  const changeStartDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStartDate(event.format("YYYY/MM/DD HH:mm"));
  }
  const changeEndDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(event.format("YYYY/MM/DD HH:mm"));
  }

  const handleDelOpen = () => {
    setOpen1(true);
  };

  const handleDialogClose = () => {
    setOpen1(false);
  };
  const handleDialogClose4 = () => {
    setOpen4(false);
  };

  const params = { // 渡したいパラメータをJSON形式で書く
    category: category,
    keyword: keyword
  };
  var getParams = new URLSearchParams(params);
  // TextfieldとButtonIconを合体させたコンポーネントの作成
  const AddButton = () => {
    const addButtonClick = () => {

      if (bf == "/Column") {
        ReactGA.event({
          category: "Search Colmn Button",
          action: "Search Colmn Button",
          label: keyword, // Optional
        })
      };
      const aaa = document.getElementById("bk");
      bk?.click();
    };
    return (
      <IconButton onClick={() => addButtonClick()}>
        <SearchIcon />
      </IconButton>
    );
  };
  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
  const resData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try {
      const bodyData = {
        category: "9"
      };
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          return jsondata;
        })
        .catch(error => {
          setLoading(false);
        });;
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

      const resSeoData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_SEO_API_URL;
    try{
      let bodyData;
      bodyData= {
      category: "24",
      keyword: "columndetail"
      }

   var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
    });;
      setLoading(false);
    }catch{
      setLoading(false);
    }
};


  const resData2 = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try {
      let bodyData;
      if(bf == "/Column"){
       bodyData = {
        category: "17",
        keyword: _id
      };
      }else{
       bodyData = {
        category: "18",
        keyword: _id
      };
      }
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          return jsondata;
        })
        .catch(error => {
          setLoading(false);
        });;
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };
  useEffect(() => {
    (async function () {
      const data = await resData();
      setPosts(data);
      setLoading(false);
    })();
  }, [reload]);
  useEffect(() => {
    (async function () {
      var res =[];
      const data = await resSeoData();
      setPostsSeo(data);
    })();
   }, []);
  useEffect(() => {
    (async function () {
      const data2 = await resData2();
      if(data2 && data2.length > 0){
      setTitle(data2[0].title);
      setCreateDate(data2[0].date);
      setTag(data2[0].tag);
      setStartDate();(data2[0].start_date);
      setEndDate(data2[0].end_date);
      setTextareaContents(data2[0].content);
      setTextareaContentsSub(data2[0].contentSub);
      if (element2.current.children.length == 0) {
        const localContents = extractLocalContents(data2[0].content)
        element2.current.appendChild(document.createRange().createContextualFragment(localContents))
        setLoading(false);
      }
    }
    })();
  }, []);



  useEffect(() => {
    if (open6) {
      (async () => {
        const localContents = await extractLocalContents(textareaContents)
        const externalScriptElements = await extractExternalScriptElements(textareaContents)
        if (externalScriptElements) {
          await Promise.all(externalScriptElements.map((scriptElement) => {
            if (isScriptAlreadyInserted(scriptElement)) {
              return Promise.resolve()
            }

            return new Promise((resolve) => {
              scriptElement.addEventListener('load', resolve)
              document.head.appendChild(scriptElement)
            })
          }))
        }
        element.current.appendChild(document.createRange().createContextualFragment(localContents))

      })();
    }
  }, [open6]);

  async function getTag() {

    const data = await resData();
    setPosts(data);
    setLoading(false);
  }

  const REG_DETECT_SCRIPT_TAGS = "/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gmi";

  function extractLocalContents(textareaContents) {
    return textareaContents.replace(REG_DETECT_SCRIPT_TAGS, (match) => {
      const scriptFragment = document.createRange().createContextualFragment(match);
      const scriptElement = scriptFragment.querySelector('script')
      if (scriptElement.src === '') return match
      return ''
    })
  }

  function extractExternalScriptElements(textareaContents) {
    const scriptElements = textareaContents.match(REG_DETECT_SCRIPT_TAGS)
    if (!scriptElements) return []
    return scriptElements.map((match) => {
      const scriptFragment = document.createRange().createContextualFragment(match);
      return scriptFragment.querySelector('script')
    }).filter(scriptElement => scriptElement.src !== '')
  }
  const validateRequired = (value: string) => !!value.length;
  function isScriptAlreadyInserted(scriptElement) {
    return Array.from(document.querySelectorAll('script')).some(s => s.src === scriptElement.src)
  }
  function validateUser(user: User) {
    return {
      name: !validateRequired(user.name)
        ? '必須です'
        : '',
    };
  }

  //CREATE action
  const handleCreateUser: MRT_TableOptions<User>['onCreatingRowSave'] = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      setMsg("langID00075");
      setMsgOpenErr(true);
      setTimeout(() => {
        setMsgOpenErr(false);
      }, 5000);
      return;
    }
    setValidationErrors({});
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try {
      const bodyData = {
        category: "10",
        id: uuidv4(),
        name: values.name
      };
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          getTag();
          table.setCreatingRow(false)
        })
        .catch(error => {
          setLoading(false);
        });
      setLoading(false);
    } catch {
      setLoading(false);
    }

  };

  //UPDATE action
  const handleSaveUser: MRT_TableOptions<User>['onEditingRowSave'] = async ({
    values,
    table,
    row
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try {
      const bodyData = {
        category: "11",
        id: row.original.id,
        name: values.name
      };
      var getParams = new URLSearchParams(params);
      const headers = new Headers({
        "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
        'Access-Control-Allow-Credentials': 'true'
      });
      var params_str = params.toString();
      setLoading(true);
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData)
      })
        .then((response) => {
          if (!response.ok) {
            setLoading(false);
            throw new Error('status is not 200');
          }
          return response.json();
        })
        .then(jsondata => {
          setLoading(false);
          getTag();
          table.setEditingRow(null);
        })
        .catch(error => {
          setLoading(false);
        });
      setLoading(false);
    } catch {
      setLoading(false);
    }

  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<User>) => {
    if (window.confirm('本当に削除してもよろしいでしょうか')) {
      const url = process.env.REACT_APP_COLUMN_API_URL;
      try {
        const bodyData = {
          category: "12",
          id: row.original.id
        };
        var getParams = new URLSearchParams(params);
        const headers = new Headers({
          "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
          'Access-Control-Allow-Credentials': 'true'
        });
        var params_str = params.toString();
        setLoading(true);
        return fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(bodyData)
        })
          .then((response) => {
            if (!response.ok) {
              setLoading(false);
              throw new Error('status is not 200');
            }
            return response.json();
          })
          .then(jsondata => {
            setLoading(false);
            getTag();
          })
          .catch(error => {
            setLoading(false);
          });
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };

  const columns = useMemo<MRT_ColumnDef<Tag>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'name',
        header: '',
        size: 500,
        grow: false,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.name,
          helperText: validationErrors?.name,
          //remove any previous validation errors when user focuses on the input
          //optionally add validation checking for onBlur or onChange
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              name: undefined,
            }),
        },
      },
    ],
    [posts],
  );
  const data = posts
  const table = useMaterialReactTable({
    columns,
    data,
    enableEditing: true,
    createDisplayMode: 'modal',
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    onCreatingRowSave: handleCreateUser,
    onCreatingRowCancel: () => {
      //clear any validation errors
    },
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveUser,
    positionCreatingRow: 'top', //default is 'top'
    defaultColumn: {
      // minSize: 1100,
      // width:"100%"
    },
    enableDensityToggle: false,
    enableColumnResizing: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableClickToCopy: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    paginationDisplayMode: 'pages',
    enableSorting: false,
    autosizeColumns: "none",
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    muiDetailPanelProps: () => ({
    }),
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {
      },
    }),
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">追加</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">更新</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        variant="contained"
        onClick={() => {
          table.setCreatingRow(true); //simplest way to open the create row modal with no default values
          //or you can pass in a row object to set default values with the `createRow` helper function
          // table.setCreatingRow(
          //   createRow(table, {
          //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
          //   }),
          // );
        }}
      >
        追加
      </Button>
    ),
  });



  return (
    <Box
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 0, sm: 13 },
          pb: { xs: 0, sm: 0 },
        }}
      >
        <Helmet>
          <title>{title}</title>
          <meta name="keywords" content={textareaContentsSub} />
                {(() => {
                  const tags = [];
                  for (let i in tag) {
                    tags.push(<meta name="keywords" content={tag[i]} />)
                  }
                  return tags;
                })()}
                  {(() => {
                  const tags = [];
                  for (let i in postsSeo) {
                    tags.push(<meta name="keywords" content={postsSeo[i].keyword} />)
                  }
                  return tags;
                })()}
        </Helmet>
        <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
        </InputLabel>
        <Container maxWidth={false}>
          <TextField
            id="email-hero"
            hiddenLabel
            fullWidth
            variant="outlined"
            placeholder={intl.formatMessage({ id: "langID00086" })}
            //value={location.state["keyword"]}
            defaultValue={keyword}
            autoComplete='off'
            InputProps={{ endAdornment: <AddButton /> }}
            onChange={handleChangeInput}
            sx={{ height: 60 }}
            onKeyDown={e => {
              // e.keyCodeは常に0になる
              if (e.key === 'Enter') {
                // エンターキー押下時の処理
                // document.getElementById("demo-form").submit();
                if (bf == "/Column") {
                  ReactGA.event({
                    category: "Search Button",
                    action: "Search Button",
                    label: keyword, // Optional
                  })
                };
                const aaa = document.getElementById("bk");
                bk?.click();
                //setRefreshKey(old => old + 1);
              }
            }}
          />
        </Container>
        <Typography
          sx={{
            display: { xs: 'none', md: 'flex' },
            gap: 0.5,
            textAlign: 'center',
            color: 'text.secondary',
            width: { sm: '100%', md: '80%' },
          }}
        >

        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          useFlexGap
          sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
        ></Stack>
        <Link hidden id="sc" to={"/search?" + getParams} state={{ keyword: keyword, category: category }}>テキスト</Link>
        <Link hidden id="returnButton" to={"/ColumnManage"} state={{ keyword: keyword }}>テキスト</Link>
      </Container>
      <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <br />
        <Container maxWidth="xl"
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div className={mok && auth ? '' : 'hidden'} style={{ visibility: mok ? "visible" : "hidden" }}>
            <Typography variant="h5" gutterBottom>コラム詳細</Typography>

            <div>
              サムネイル  ※サムネイルはXXXpx×XXXpxで表示されます<br />
              <br />
              <Typography sx={{ marginTop: "-20px", marginLeft: "-20px" }}>
                <input id="img" type="file" accept="image/*,.png,.jpg,.jpeg,.gif,.svg,.ico" onChange={getImage} />
                <input hidden type="button" value="保存" onClick={handleUpload} />
                {thumbnail != "" && <img
                  height={90}
                  width={90}
                  src={thumbnail}
                  loading="lazy"
                />}
              </Typography>
            </div>
            <br />
            タイトル
            <TextField
              id="email-hero"
              hiddenLabel
              fullWidth
              variant="outlined"
              placeholder="タイトル"
              defaultValue={title}
              autoComplete='off'
              onChange={changeTitle}
              sx={{ height: 60 }}
            />
            <br />
            日付
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
              <DemoContainer components={['DatePicker']} >
                <DatePicker  hiddenLabel placeholder="日付" onChange={changeCreateDate} defaultValue={dayjs()} inputFormat='yyyy/MM/dd' format="YYYY/MM/DD" slotProps={{ calendarHeader: { format: 'YYYY年MM月' } }} sx={{ height: 60, width: 180 }} />
              </DemoContainer>
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
              <DemoContainer components={['DateTimePicker']}>
                公開期間
                <Box display="flex" flexDirection="row" gap={2} sx={{ marginTop: "-20px" }} >
                  <DateTimePicker hiddenLabel onChange={changeStartDate} placeholder="公開開始日時" defaultValue={dayjs()} format="YYYY/MM/DD HH:mm" slotProps={{ calendarHeader: { format: 'YYYY年MM月' } }} sx={{ height: 60, width: 230 }} />
                  <Typography align="center" sx={{ display: "flex", height: 60, justifyContent: "center", alignItems: "center" }}  >ー</Typography>
                  <DateTimePicker hiddenLabel onChange={changeEndDate} placeholder="公開終了日時" format="YYYY/MM/DD HH:mm" slotProps={{ calendarHeader: { format: 'YYYY年MM月' } }} sx={{ height: 60, width: 230 }} />
                </Box>
              </DemoContainer>
            </LocalizationProvider>
            <br />
            タグ<br /><Button variant="contained" onClick={tagManage} color="secondary" sx={{ width: "150px" }}>タグ管理</Button><br />
            <FormControl sx={{ m: 1, width: 800, marginLeft: "-0px" }}>
              <InputLabel id="demo-multiple-chip-label"></InputLabel>
              <Select sx={{ height: 70 }}
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={tag}
                placeholder="タグ"
                onChange={tagChange}
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {data.map(v => v.name).map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, tag, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <br />
            内容
            <SummernoteLite
              ref={noteRef}
              defaultCodeValue={textareaContents}
              value={textareaContents}
              lang='ja-JP'
              height={350}
              dialogsInBody="false"
              blockquoteBreakingLevel={0}
              toolbar={[
                ['style', ['style']],
                ['font', ['bold', 'underline', 'clear', 'strikethrough', 'superscript', 'subscript']],
                ['fontsize', ['fontsize']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'hr']],
                ['view', ['codeview', 'help']]
              ]}
              options={{
                lang: 'ru-RU',
                height: 350,
                dialogsInBody: true,
                toolbar: [
                  ['style', ['style']],
                  ['font', ['bold', 'underline', 'clear']],
                  ['fontname', ['fontname']],
                  ['para', ['ul', 'ol', 'paragraph']],
                  ['table', ['table']],
                  ['insert', ['link', 'picture']],
                  ['view', ['fullscreen', 'codeview']]
                ]
              }}
              callbacks={{
                onImageUpload: function (files) {
                  uploadImage(files);
                },
                onChange: function (content) {
                  onChange(content);
                }
              }}
            />
            <Button variant="contained" color="secondary" onClick={handleClickOpen} sx={{ width: "150px" }}>プレビュー</Button>
            <br /><br />
            <Button variant="contained" onClick={saveColumn} sx={{ width: "150px" }}>保存</Button>
            <Button variant="contained" onClick={saveTempColumn} color="secondary" sx={{ width: "150px" }}>一時保存</Button>
            {category == "update" && <Button variant="contained" onClick={handleDelOpen} color="error" sx={{ width: "150px" }}>削除</Button>}

          </div>
          <div className={!mok ? '' : 'hidden'} style={{ visibility: !mok ? "visible" : "hidden" }}>
            <Button to={bf} id="bk" component={Link} state={{ keyword: keyword }}
              className="scroll-to-top" startIcon={<ArrowCircleLeftIcon />}>
              戻る
            </Button>
            <br /><br />
            <h2 class="columnTitle">{title}</h2>
            <Box sx={{ justifyContent: 'flex-end', bottom: '0px', position: 'relative' }}>
              <Typography variant="h5" sx={{ textAlign: 'right', justifyContent: 'flex-end', bottom: '0px', position: 'absolute', right: '0px', top: '-140px' }}>
                {createDate}<br />
                {(() => {
                  const tags = [];
                  for (let i in tag) {
                    tags.push(<Button to={bf} component={Link} state={{ keyword: '#' + tag[i] }} size="small" style={{ fontSize: '1em', color: 'black' }} id={title} >#{tag[i]} </Button>)
                  }
                  return tags;
                })()}
              </Typography>
            </Box>

            <div className="App2">
              <div ref={element2} />
            </div>
            <Box bottom="0px" sx={{ justifyContent: 'flex-end', bottom: '0px', position: 'relative' }}>
              <Typography variant="h6" sx={{ justifyContent: 'flex-end', bottom: '0px', position: 'absolute', right: '0px' }}>
                <Button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  className="scroll-to-top" startIcon={<ArrowCircleUpIcon />}>
                  一番上に戻る
                </Button>
              </Typography>
            </Box>
          </div>
        </Container>
        <Collapse in={open3}>
          <Alert
            sx={{ mb: 2 }}
          >
            "削除完了しました。"
          </Alert>
        </Collapse>

        <Dialog
          open={open1}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <Stack my={1} direction="row" justifyContent="end" spacing={1}>
              <IconButton aria-label="delete" onClick={handleDialogClose} sx={{ zIndex: 10000 }} >
                <CloseIcon />
              </IconButton>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              本当に削除してもよろしいでしょうか
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={deleteColumn} autoFocus>
              削除
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={open6}
          //PaperComponent={handleClose}
          aria-labelledby="draggable-dialog-title"
          maxWidth="xl"
          fullWidth="true"
        >
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            <Stack my={1} direction="row" justifyContent="end" spacing={1}>
              <IconButton aria-label="delete" onClick={handleClose} sx={{ zIndex: 10001 }} >
                <CloseIcon />
              </IconButton>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <div><h2 class="columnTitle">{title}</h2></div>
            <Box sx={{ justifyContent: 'flex-end', top: '0px', position: 'relative' }}>
              <Typography variant="h5" sx={{ textAlign: 'right', justifyContent: 'flex-end', top: '0px', position: 'absolute', right: '0px', top: '-140px' }}>
                {createDate}<br />
                {(() => {
                  const tags = [];
                  for (let i in tag) {
                    tags.push(<Button to="/Column" state={{ keyword: '#' + tag[i] }} noWrap size="small" style={{ fontSize: '1em', color: 'black' }} id={title} >#{tag[i]} </Button>)
                  }
                  return tags;
                })()}
              </Typography>


            </Box>
            <div className="App">
              <div ref={element} />
            </div>
          </DialogContent>
          <DialogActions>
          </DialogActions>
        </Dialog>
        <Dialog
          open={open4}
          onClose={handleDialogClose4}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <Stack my={1} direction="row" justifyContent="end" spacing={1}>
              <IconButton aria-label="delete" onClick={handleDialogClose4} sx={{ zIndex: 10000 }} >
                <CloseIcon />
              </IconButton>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <MaterialReactTable table={table} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
}